import { EmailSignIn } from "./EmailSignIn";
import { GoogleSignIn } from "./GoogleSignIn";

export function SignInOptions() {
  return <div className="signin-options">
    <GoogleSignIn />
    <div className="signin-divider"><span>or</span></div>
    <EmailSignIn />
  </div>;
}
